import { type Color } from '@mui/material'

export const orange = {
  100: '#FDF0E6',
  200: '#FBDAC0',
  300: '#F6B681',
  400: '#F3A05B',
  500: '#F18A35',
  600: '#E96F26',
  700: '#BE5702',
  800: '#8E4102',
  900: '#5F2C01',
} satisfies Partial<Color>
